import {oidcClient} from '../helpers/oidcClient.ts';
import {getLanguageCode} from '../i18n.ts';
import {
  createNewTourURL,
  createToursURL,
  createTourURL,
} from '../urlHandling/urlCreate.ts';
import {normalizeURL} from '../urlHandling/urlNormalizer.ts';
import {resolveDeployPrefix} from './deployPrefixResolver.ts';

export function finishAuthenticationProcedure() {
  const postLogoutUrl = localStorage.getItem('appPostLogoutURL');
  if (postLogoutUrl) {
    localStorage.removeItem('appPostLogoutURL');
    document.location = postLogoutUrl;
    return;
  }
  const preLoginUrl = localStorage.getItem('appPreLoginURL');
  if (!preLoginUrl) {
    return;
  }
  try {
    const searchParams = new URLSearchParams(document.location.search);
    oidcClient.handleStateIfInURL(searchParams).then(async (results) => {
      switch (results.status) {
        case 'completed': {
          localStorage.removeItem('appPreLoginURL');
          const {kind, bag} = normalizeURL(
            preLoginUrl,
            getLanguageCode(),
            undefined,
            resolveDeployPrefix(),
          );
          if (['tour', 'recordedtrack'].includes(kind)) {
            const url = bag.tourId
              ? createTourURL(
                  bag.tourId,
                  kind === 'tour' ? 'normal' : 'recordedtrack',
                  getLanguageCode(),
                )
              : createNewTourURL(getLanguageCode());
            document.location = location.origin + url;
          } else {
            document.location =
              location.origin + createToursURL(getLanguageCode());
          }
          return;
        }
        case 'invalid':
        case 'error': {
          // Display an error message
          console.log('Login failed', results.msg);
          return;
        }
        case 'nothing': {
          // Do nothing
          return;
        }
      }
    });
  } catch (error) {
    console.log('Login failed', error);
  }
}
